module.exports = __webpack_public_path__ + "static/color-multi.77acba03.png";